<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="360">
      <v-card>
        <v-card-title class="headline">{{ title }}</v-card-title>
        <v-card-text>{{ content }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat @click="setMessageModal()">{{ $gettext('ok') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { SET_MESSAGE_MODAL } from '@/store/mutation-types';
import ErrorService from '@/services/ErrorService';

export default {
  name: 'MessageModal',
  data() {
    return {
      dialog: false,
    };
  },
  computed: {
    title() {
      if (typeof (this.message) !== 'object') return this.$gettext('message');
      return ErrorService.getTitle(this.message);
    },
    content() {
      if (typeof (this.message) !== 'object') return this.message;
      return ErrorService.getContent(this.message);
    },
    ...mapState({
      message: state => state.toggle.messageModal,
    }),
  },
  watch: {
    message(newMessage) {
      this.dialog = !!newMessage;
    },
  },
  methods: {
    ...mapMutations([SET_MESSAGE_MODAL]),
  },
};
</script>
